import { PathQueryKey } from "./page/pageProp";

// The Home Workspace: its own Noun (query-omega-oql oql/app/home.oql:7-15), path system:#home. The frontend
// reaches it ONLY through the generic public wrappers -- Qo.Public.Api/path-query and write-data -- never a
// Home-specific endpoint, and never through get-apps (the page-prop precedent, types/page/pageProp.ts:1-3).
export const HomeKey = "omega/query-omega/home/Home" as const;

// {"type" Home "account-id" <Account Key> "app-id" <app id, or "" when the Account has no listable app>}
// (Qo.Home/mk-home!, home.oql:19-24). "app-id" is the stored choice while the Account can still list that app,
// else the server's default (home.oql:33-90).
export interface HomeRecord {
  type: typeof HomeKey;
  "account-id": string;
  "app-id": string;
}

// The caller's Home Record: record-type "home" is the key Qo.Pq.Home registers under (query-omega-oql
// oql/app/path/path-query/home.oql:27); with no "record-name" it resolves to the caller, as system:#home does
// (Qo.UserApps/path-account!, oql/app/user-apps.oql:32-36, called at path-query/home.oql:11).
export const homePathQuery = { type: PathQueryKey, "record-type": "home" } as const;

// The Home Workspace's app id, or undefined when the Record names none ("").
export const homeAppOf = (record: HomeRecord | undefined): string | undefined =>
  record?.["app-id"] || undefined;

// The Record a "Set as home" writes: the caller's own Record with only "app-id" changed. Qo.Home/write-data!
// reads exactly "account-id" (the self gate) and "app-id" (membership, then stored) (home.oql:120-125). The
// resolve + set + write shape of Qo.Public.Api/set-selected-app! (query-omega-api oql/app/public/api.oql:396-402).
export const homeWrite = (record: HomeRecord, appId: string): HomeRecord => ({
  type: HomeKey,
  "account-id": record["account-id"],
  "app-id": appId,
});
